import { useEffect, useState } from 'react';

const KEY = 'depthme_offer_end';
const DURATION_MS = 15 * 60 * 1000;

function readEnd() {
  try {
    const stored = Number(window.sessionStorage.getItem(KEY));
    if (stored > 0) return stored;
    const end = Date.now() + DURATION_MS;
    window.sessionStorage.setItem(KEY, String(end));
    return end;
  } catch {
    return Date.now() + DURATION_MS;
  }
}

// Session-scoped so a reload keeps counting down instead of resetting.
export function useCountdown(enabled) {
  const [remaining, setRemaining] = useState(DURATION_MS);

  useEffect(() => {
    if (!enabled) return undefined;
    const end = readEnd();
    const tick = () => setRemaining(Math.max(0, end - Date.now()));
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [enabled]);

  const mins = String(Math.floor(remaining / 60000)).padStart(2, '0');
  const secs = String(Math.floor((remaining % 60000) / 1000)).padStart(2, '0');
  return { label: `${mins}:${secs}`, expired: remaining === 0 };
}
